/**
 * assume an object with this structure is present: 
 * 
 * window.__scpit_embeds = [{
 *   data_url: "http://some_url?with_parameters",
 *   target_id: "html_id",
 *   render_parameters: {
 *     type: "v0",
 *     ... opaque params use by widget type.
 *   },
 *   rendered: false // this will be set to true by the renderer
 * }]
 * 
 */


const regeneratorRuntime = require("regenerator-runtime");
const Responsive = require("./widgets/responsive").Responsive;
const List = require("./widgets/list").List;
const Carousel = require("./widgets/carousel").Carousel;
const React = require("react");
const ReactDOM = require("react-dom");

// available locales (must match utils/locale.js)
require('dayjs/locale/fr');
require('dayjs/locale/en');
require('dayjs/locale/de');
require('dayjs/locale/es');
require('dayjs/locale/en-gb');
require('dayjs/locale/se');

function render() {
    const embeds = window.__scpit_embeds;
    if (!embeds) {
        console.error("Unable to render embeds");
    }
    for (i in embeds) {
        const embed = embeds[i]
        if (!embed.rendered) {
            embed.rendered = true;
            do_render(embed);
        }
    }
}

function do_render({ target_id, data_url, widget_type, render_parameters }) {
    if (widget_type === "responsive") {
        ReactDOM.render(<Responsive {...render_parameters} data_url={data_url} />, document.getElementById(target_id));
    } else if (widget_type === "list") {
        ReactDOM.render(<List {...render_parameters} data_url={data_url} />, document.getElementById(target_id));
    } else if (widget_type === "carousel") {
        ReactDOM.render(<Carousel {...render_parameters} data_url={data_url} />, document.getElementById(target_id));
    } else {
        console.error(`Unknown widget type ${widget_type}`);
    }
}


// register renderer
if (!window.__scpit_widget_render) {
    window.__scpit_widget_render = render;
}

window.__scpit_widget_render();


if (!window.yt_players) {
    document.write('<script type="text/javascript" src="https://www.youtube.com/player_api"></script>')
    window.yt_players = {};
    function onYTPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING) {
            var playingIframeId = event.target.getIframe().id;
            for (var id in yt_players) {
                if (id !== playingIframeId) {
                    yt_players[id].pauseVideo();
                }
            }
        }
    }

    window.yt_players_to_load = []
    window.yt_api_ready = false;
    function onYouTubeIframeAPIReady() {
        window.yt_api_ready = true;
        for (var i = 0; i < yt_players_to_load.length; i++) {
            doLoadYouTubePlayer(yt_players_to_load[i]);
        }
    }

    function doLoadYouTubePlayer(id) {
        yt_players[id] = new YT.Player(id, { events: { 'onStateChange': onYTPlayerStateChange } });
    }

    window.loadYouTubePlayer = function (id) {
        if (yt_api_ready) {
            doLoadYouTubePlayer(id);
        } else {
            yt_players_to_load.push(id);
        }
    }
}




